import React from 'react'
import { Tab, Tabs } from '@mui/material'
import {
    Business as BusinessIcon,
    LocalOffer as LocalOfferIcon,
    DirectionsCar as DirectionsCarIcon,
} from '@mui/icons-material'

import VehicleHelpTab from './VehicleHelpTab'
import SaleHelpTab from './SaleHelpTab'
import CompanyHelpTab from './CompanyHelpTab'

type SearchHelpTabType = 'VEHICLE' | 'SALE' | 'COMPANY'

const TAB_LIST = [
    {
        label: 'Vehicle',
        value: 'VEHICLE',
        icon: <DirectionsCarIcon />,
        tab: <VehicleHelpTab />,
    },
    {
        label: 'Sale',
        value: 'SALE',
        icon: <LocalOfferIcon />,
        tab: <SaleHelpTab />,
    },
    {
        label: 'Company',
        value: 'COMPANY',
        icon: <BusinessIcon />,
        tab: <CompanyHelpTab />,
    },
]

const SearchHelpTabs: React.FC = () => {
    const [tab, setTab] = React.useState<SearchHelpTabType>('VEHICLE')
    const selected = TAB_LIST.find(({ value }) => value === tab)
    return (
        <>
            <Tabs
                value={tab}
                indicatorColor="primary"
                textColor="primary"
                variant={TAB_LIST.length > 3 ? 'scrollable' : 'fullWidth'}
                scrollButtons={TAB_LIST.length > 3}
                onChange={(e, newValue): void => setTab(newValue)}
                sx={{ pr: '48px' }}
            >
                {TAB_LIST.map(({ label, value, icon }) => (
                    <Tab
                        label={label}
                        value={value}
                        icon={icon}
                        sx={{
                            flexDirection: 'row',
                            '& .MuiSvgIcon-root': {
                                paddingRight: '10px',
                            },
                            minHeight: '0px',
                            minWidth: '160px',
                        }}
                    />
                ))}
            </Tabs>
            {selected?.tab}
        </>
    )
}

export default SearchHelpTabs
